import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

export const ProtectedRoute = ({ children, accessPermission = [] }) => {
  const user = useSelector((state) => {
    return state.user?.userData?.user;
  });

  const isLoggedIn = localStorage.getItem('authToken');

  if (!isLoggedIn) {
    return <Navigate to="/login" />;
  }

  if (user && accessPermission.includes(user?.accessLevel)) {
    return children;
  }

  return <Navigate to="/unauthorized" />;
};
